import { render, staticRenderFns } from "./Eventi.vue?vue&type=template&id=2053ea10&"
import script from "./Eventi.vue?vue&type=script&lang=js&"
export * from "./Eventi.vue?vue&type=script&lang=js&"
import style0 from "./Eventi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Eventi.vue?vue&type=style&index=1&css-scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports